import { Injectable } from '@angular/core';
import { URLSearchParams, Http } from "@angular/http";
import {Observable} from  "rxjs/Observable";
import { HttpService } from './http-service';
import 'rxjs/add/operator/map';
import {LoadingService} from "./loading-service";
import {AuthStore} from '../stores/auth-store';

/*
  Generated class for the HttpReserveProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class HttpChatProvider extends HttpService{

  constructor(protected http: Http, protected loadingService:LoadingService, protected authStore:AuthStore) {
  	super(http, loadingService, authStore);
  }

  /**
   * 記録登録処理
   */
  save(data:object): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/chats/save");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  /**
   * 記録取得
   */
  getList(room_id:string): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("condition", JSON.stringify({room_id:room_id}));
    userParam.set("api", "/chats/getList");
    var options = super.buildParam(userParam);

    return super.get(options);
  }

  /**
   * 記録取得（写真付き限定）
   */
  getListHasPhotos(room_ids:Array<any>): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("condition", JSON.stringify({room_ids:room_ids}));
    userParam.set("api", "/chats/getListHasPhotos");
    var options = super.buildParam(userParam);

    return super.get(options);
  }

  /**
   * チャット削除処理
   */
  removeChat(chat_id:string): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/chats/removeChat");
    var options = super.buildParam(userParam);

    return super.post(options, {chat_id: chat_id});
  }
}


// WEBPACK FOOTER //
// ./src/providers/http-chat.ts